import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";
import {useSelector} from "react-redux";
import {getSelectedCustomer, getUserConfigurations} from "../../store/slices/userConfigurationsSlice";
import {useTranslation} from "react-i18next";
import {getAppData} from "../../store/slices/appSlice";


const RadioButtonCustomer = (props) => {

    const  {
        onCheck,
        defaultChecked,
        value,
        // eslint-disable-next-line
        customer
    } = props;


    const { t } = useTranslation();

    const [isChecked, setIsChecked] = useState(value);
    const appData = useSelector(getAppData);
    let selectedCustomer = useSelector(getSelectedCustomer);
    const selectedVehicleType = appData.input.vehicleType || appData.touchpointConfig.defaults.vehicleCondition;

    if(!selectedCustomer) {
        selectedCustomer = appData.touchpointConfig.defaults.customer;
        onCheck(!isChecked);
    }

    const allUserConfigurations = useSelector(getUserConfigurations) || [];
    const userConfiguration = allUserConfigurations.find(c => c.EIM === appData.input.EIM && c.selectedProduct && c.vehicleType === selectedVehicleType && c.customer === selectedCustomer);

     useEffect(()=>{
        if(defaultChecked && !selectedCustomer) {
            onCheck();
        }
    }, [onCheck, defaultChecked, selectedCustomer]);


    const _onClick = () => {
        onCheck(!isChecked);
        setIsChecked(!isChecked);
    }

    if(!appData && !userConfiguration) {
        return null;
    }

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}RadioButton`}>
                <input
                    className={selectedCustomer === value ? `${CONST.CSS_NAMESPACE}RadioButton-is-checked` : ''}
                    onChange={_onClick}
                    value={value}
                    type={"radio"}
                    name={"Customer Section"}
                    checked={defaultChecked && (!selectedCustomer || selectedCustomer === value)}
                />
                <label className={`${CONST.CSS_NAMESPACE}RadioButton-label`}>
                    {t(`Customer_${customer.typeOfCustomer}`)}
                </label>
            </div>
        </>
    );
};

RadioButtonCustomer.propTypes = {
        onCheck: PropTypes.func.isRequired,
        defaultChecked: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired,
        customer: PropTypes.object.isRequired,
    };



export default RadioButtonCustomer;
